import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const kycVerifyOtp = createAsyncThunk(
  "kycVerifyOtp/kycVerifyOtpUsers",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post("", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

const kycVerifyOtpSlice = createSlice({
  name: "kycVerifyOtp",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(kycVerifyOtp.pending, (state) => {
        state.loading = true;
      })
      .addCase(kycVerifyOtp.fulfilled, (state, action) => {
          

        state.loading = false;
        state.data = action.payload;
      })
      .addCase(kycVerifyOtp.rejected, (state, action) => {
        console.log(action);
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default kycVerifyOtpSlice.reducer;
